import { clearCurrentUserCache } from "./currentUser";

/**
 * 会话失效时由 request 拦截器触发，App 等监听后清空 UI 登录态并打开登录弹窗。
 */
export const SESSION_INVALID_EVENT = "mg:session-invalid";

export function clearAuthSessionAndNotify() {
  try {
    localStorage.removeItem("token");
  } catch (e) {
    // ignore
  }
  clearCurrentUserCache();
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SESSION_INVALID_EVENT));
  }
}
